import React from "react";
import { useAppSelector } from "../../../redux/store";
import { FaInfoCircle } from "react-icons/fa";
import Collabse from "../../../components/Collabse";
import TransferList from "./TransfersList";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Transfers = () => {
  const navigate = useNavigate();
  const booking = useAppSelector((state) => state.booking);
  const upgrades = booking.bookingUpgrades;
  const { t } = useTranslation();

  const navigateHandler = () => {
    navigate("/upgrades");
  };

  const requestedBefore = sessionStorage.getItem("lmxancillaries");

  return (
    <Collabse Header={Header}>
      <div className="row">
        <div className="col-12">
          <TransferList />
        </div>

        <div className="col-12">
          {upgrades.hasTransferUpgrade && !requestedBefore && (
            <button
              className="btnRounded btnOrange ms-auto"
              onClick={navigateHandler}
            >
              {t("privateTransfer.confirmtButton2", {
                price: upgrades.transferPerPerson,
              })}
            </button>
          )}
        </div>
      </div>
    </Collabse>
  );
};

const Header = () => {
  const { t } = useTranslation();

  return (
    <h5>
      <FaInfoCircle />
      {t("bookingDetails.transfers.title")}
    </h5>
  );
};

export default Transfers;
